"use client";
import {
  useCheckboxCheck
} from "../__chunks/BX7FFG2R.js";
import "../__chunks/6XBVQI3K.js";
import {
  SelectItemCheckedContext
} from "../__chunks/TKSBJDO3.js";
import "../__chunks/3D6OCOHF.js";
import "../__chunks/MADQZZRL.js";
import "../__chunks/TE637IA7.js";
import "../__chunks/XXVAHUAO.js";
import "../__chunks/J55AVALY.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/5M6RSQEC.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/select/select-item-check.ts
import { useContext } from "react";
var TagName = "span";
var useSelectItemCheck = createHook(
  function useSelectItemCheck2(_a) {
    var _b = _a, { store, checked } = _b, props = __objRest(_b, ["store", "checked"]);
    const context = useContext(SelectItemCheckedContext);
    checked = checked != null ? checked : context;
    props = useCheckboxCheck(__spreadProps(__spreadValues({}, props), { checked }));
    return props;
  }
);
var SelectItemCheck = forwardRef(function SelectItemCheck2(props) {
  const htmlProps = useSelectItemCheck(props);
  return createElement(TagName, htmlProps);
});
export {
  SelectItemCheck,
  useSelectItemCheck
};
